import React, { useEffect, useContext, useState, useRef } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { usePDF, Resolution } from 'react-to-pdf';
import {
  Box,
  Container,
  Hidden,
  Button,
} from '@material-ui/core';

import Moment from 'moment'
Moment.locale('fr')

import PopupNotifContext from "../contexts/PopupNotifContext"
import UserContext from "../contexts/UserContext"
import LanguageContext from "../contexts/LanguageContext"

import SkillResultCard from "../components/ui/Formation/SkillResultCard"
import NewCertifChart from "../components/ui/NewCertifChart"
import Rapport from "../components/ui/Formation/Rapport"

import { ModalTuto } from "../components/ui/AdminDashboard/Home"

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import fakeVideoTuto from "../images/fakeVideoTuto.png"
import fakeChartDataImage from '../images/fakeChartData.png'


import APIS, {GLB_URL_APIS} from "../utils/APIS"


const MyCertif = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const {
    currentUser,
    actPlan,
    actFormation,
    actIndex,
    lastDoneIndex,
  } = useContext(UserContext)

  const [seeTuto, setSeeTuto] = useState(false)


  const [data, setData] = useState(null)
  useEffect(() => {
    getCertifInfos()
  }, [])


  const getCertifInfos = () => {
    APIS.getCertifInfos().then((result) => {
      if (result?.message === "getCertifInfos") {

        //on va chercher les softskills par années
        let skillsByYear = [[], [], []]
        result?.contents?.forEach((module) => {
          let findModuleInPlan = result?.plan?.find((p) => p.id === module.id)
          let findInCertif = result?.certification?.find((c) => c.id === module.id)
          if (findModuleInPlan && Number.isInteger(parseInt(findModuleInPlan?.annee)) && findInCertif) {
            module?.softSkills?.forEach((skill) => {
              //on va chercher dans la certif si on prend ce skill
              let findSkillInCertif = findInCertif?.softSkills?.find((skillCertif) => (skillCertif.key === skill.key))
              if (skill.value === 'oui' && findSkillInCertif) {
                Object.keys(findSkillInCertif).forEach((key) => {
                  if (key !== "key") {
                    skill[key] = findSkillInCertif[key]
                  }
                });
                skillsByYear[parseInt(findModuleInPlan?.annee)-1].push(skill)
              }
            });
          }
        })

        //on va chercher les modules par années
        let contentsByYear = [[], [], []]
        result?.plan?.forEach((plan) => {
          if (Number.isInteger(parseInt(plan.annee))) {
            contentsByYear[parseInt(plan.annee)-1].push(plan)
          }
        })
        //on calcule l'année max (0, 1 ou 2)
        let maxYear = 0;
        if (contentsByYear[1].length > 0 && contentsByYear[2].length > 0) {
          maxYear = 2
        } else if (contentsByYear[1].length > 0) {
          maxYear = 1
        }

        //on va chercher les infos du user pour chaque softskills pour chaque années
        skillsByYear.forEach((year, index) => {
          let filterInPlan = actPlan?.filter((el) => (parseInt(el.annee) === index+1) && (el.isDone === true) && el.progress === 100)
          year.forEach((softskill) => {
            let score = 0;
            let nbr = 0
            filterInPlan.forEach((moduleInPlan) => {
              let findSkill = moduleInPlan?.resultFin[softskill.key]
              if (findSkill) {
                score+=findSkill?.score
                nbr++
              }
            })

            if (nbr > 0) {
              softskill.finalScore = parseInt(score / nbr)
            }
          })
        })

        //on trie chaque année par ordre décroissant de score
        skillsByYear.forEach((year) => {
          year = year.sort(function (a, b) {
            if (a.finalScore > b.finalScore) {
              return -1;
            }
            if (a.finalScore < b.finalScore) {
              return 1;
            }
            return 0;
          });
        })


        //on regarder la famille la plus présente pour chaque année, et donc la couleur
        let familyByYear = [[], [], []]
        let labelsCategories = ['communication','efficacite','leadership']
        skillsByYear.forEach((year, index) => {
          labelsCategories.forEach((cat) => {
            let count = year.filter((el) => el.family === cat)?.length
            familyByYear[index].push({cat : cat, count : count})
          })

        })
        familyByYear.forEach((year) => {
          year = year.sort(function (a, b) {
            if (a.count > b.count) {
              return -1;
            }
            if (a.count < b.count) {
              return 1;
            }
            return 0;
          });
        })

        //on regarde le nbr de content terminés sur le total
        let percentAllContentsEnded = 0;
        let nbrAllContents = 0;
        let nbrAllContentsEnded = 0
        actPlan?.forEach((p) => {
          nbrAllContents++
          if (p.isDone === true && p.progress === 100) {
            nbrAllContentsEnded++
          }
        })
        if (nbrAllContents > 0) {
          percentAllContentsEnded = (nbrAllContentsEnded/nbrAllContents)*100
        }


        //on regarde si on a des datas pour tous les softskills et si tout est validé
        let diplomeOK = false
        let nbrErreurDiplome = 0
        let nbrSoftSkills = 0;
        skillsByYear.forEach((year, index) => {
          year.forEach((softskill) => {
            nbrSoftSkills++
            if (softskill?.finalScore === undefined || softskill?.finalScore === null || softskill?.finalScore < softskill.validation) {
              nbrErreurDiplome++
            }
          })
        })

        let allSkills = []
        let nbrOKDiplome = nbrSoftSkills - nbrErreurDiplome;
        let percentOK = (nbrOKDiplome/nbrSoftSkills)*100
        if (percentOK >= 70) { //certification validé si supérieur ou égal à 70%
          //on doit donc calculer les datas pour le graph
          skillsByYear.forEach((year) => {
            year.forEach((skill) => {
              let find = allSkills.find((el) => el.key === skill.key)
              if (find) {
                find?.scores?.push(skill.finalScore)
              } else {
                allSkills.push({
                  key : skill.key,
                  family : skill.family,
                  scores : [skill.finalScore],
                  validation : skill.validation
                })
              }
            })
          })
          allSkills.forEach((skill) => {
            let total = 0
            let nbr = 0
            skill?.scores?.forEach((score) => {
              total+=score
              nbr++
            })
            if (nbr > 0) {
              skill.finalScore = parseInt(total / nbr)
            } else {
              skill.finalScore = 0
            }
          })
          diplomeOK = true
        } else if (percentOK >= 50) { //rattrapage

        } else { //non validé

        }

        /*console.log(percentAllContentsEnded+" % contents OK")
        console.log(percentOK+" % softskills OK")*/

        setData({percentAllContentsEnded : percentAllContentsEnded, percentOK : percentOK, plan : result?.plan, skillsByYear : skillsByYear, maxYear : maxYear, diplomeOK : diplomeOK, allSkills : allSkills})


      } else {
        setData("error")
      }
    })
  }

  /*useEffect(() => {
    console.log(data)
  }, [data])*/

  const [selectedYear, setSelectedYear] = useState(0)

  const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  const getDatasForChart = (withoutTooltips) => {

    let labels = []
    let datasets = []
    let labelsDotColors = []
    let labelsIcons = []
    let labelsCategories = ['communication','efficacite','leadership']
    let softSkillsByFamily = data?.allSkills?.sort((a, b) => a?.family?.localeCompare(b?.family)); //on trie par famille (par nom de famille croissant)
    softSkillsByFamily?.forEach((skill) => {
      labels.push(capitalizeFirstLetter(skill?.key))
      if (skill?.family === labelsCategories[0]) {
        labelsDotColors.push("rgba(255, 81, 6, 1)")
      } else if (skill?.family === labelsCategories[1]) {
        labelsDotColors.push("rgba(79, 57, 255, 1)")
      } else if (skill?.family === labelsCategories[2]) {
        labelsDotColors.push("rgba(243, 144, 255, 1)")
      }

    })

    softSkillsByFamily?.forEach((skill) => {
      //pour afficher les icones à coté des labels
      if (skill?.finalScore < skill?.validation) {
        labelsIcons.push("error")
      } else {
        labelsIcons.push(skill.family)
      }
    })

    let dashStyle = undefined
    labelsCategories?.forEach((cat, index) => {
      let arr = []
      let labelsNbr = 0
      softSkillsByFamily?.forEach((skill) => {
        if (skill.family === cat) {
          labelsNbr++
          arr.push(skill?.finalScore)
        } else {
          arr.push(0)
        }
      })


      let bgColor = ""
      let borderColor = ""
      let tooltipText = ""
      if (cat === labelsCategories[0]) {
        bgColor = "rgba(255, 81, 6, 0.2)"
        borderColor = "rgba(255, 81, 6, 1)"
        tooltipText = "Innovation et\ncommunication"
      } else if (cat === labelsCategories[1]) {
        bgColor = "rgba(79, 57, 255, 0.2)"
        borderColor = "rgba(79, 57, 255, 1)"
        tooltipText = "Éfficacité\nopérationnelle"
      } else if (cat === labelsCategories[2]) {
        bgColor = "rgba(243, 144, 255, 0.2)"
        borderColor = "rgba(243, 144, 255, 1)"
        tooltipText = "Collaboration et\nleadership"
      }


      datasets.push({
        title : index,
        data : arr,
        fill : true,
        backgroundColor: bgColor,
        borderColor: borderColor,
        borderDash : dashStyle,
        borderWidth : 1,
        pointRadius: 0,
        pointHoverRadius: 0,
        tooltipText: tooltipText,
        labelsNbr : labelsNbr,
      })
    })

    //on regarde pour lier les lignes
    let indexLabels = 0
    for (let d=0; d<datasets.length; d++) {
      //pour le premier dataset
      if (d === 0 && datasets?.length >= 2) { //pour le premier dataset
        let actDataset = datasets[d]
        let nextDataset = datasets[d+1]

        actDataset.data[actDataset?.labelsNbr] = nextDataset.data[actDataset?.labelsNbr]
      } else if (d === datasets?.length-1) { //pour le dernier dataset
        let actDataset = datasets[d]
        let firstDataset = datasets[0]
        actDataset.data[0] = firstDataset.data[0]
      } else {
        let actDataset = datasets[d]
        let nextDataset =  datasets[d+1]
        actDataset.data[indexLabels + datasets[d]?.labelsNbr] = nextDataset.data[indexLabels + datasets[d]?.labelsNbr]
      }

      indexLabels += datasets[d]?.labelsNbr
    }

    let seuilsArr = []
      softSkillsByFamily?.forEach((skill) => {
        seuilsArr.push(skill?.validation)
      })
      datasets.push({
        title : "SEUILS",
        data : seuilsArr,
        fill : true,
        backgroundColor: "rgba(254, 208, 48, 0.2)",
        borderColor: "rgba(254, 208, 48, 1)",
        borderDash : dashStyle,
        borderWidth : 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      })

    return {
      labels : labels,
      datasets : datasets,
      labelsDotColors : labelsDotColors,
      labelsIcons : labelsIcons,
      withoutTooltips : withoutTooltips,
    }
  }

  const { toPDF, targetRef } = usePDF({
    //method: 'open',
    filename : languageValues?.myCertif?.certificateName[actLanguage]+" "+currentUser?.name+" - "+Moment(new Date()).format("DD-MM-YYYY")+".pdf",
    //resolution: Resolution.HIGH,
    page: {
      orientation: "portrait",
      margin:0,
      format : [1250/4, 1768.0000001/4]
    },
    overrides: {
     /*canvas: {
       ignoreElements: function (element) {
         if (element.id === "closeButton" || element.id === "downloadButton" || element.id === "closeButtonVisible" || element.id === "downloadButtonVisible") {
           return true
         } else {
           return false
         }
      }
    },*/
   },
  });

  console.log(data)


  return (
    <>
      <Helmet>
        <title>{languageValues?.myCertif?.pageTitle[actLanguage] || ''} | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:["20px", "50px", "50px", "80px"],
            backgroundColor:"background.grey",
          }}
        >
          {/* TOP */}
          <Box sx={{
            display:"flex",
            flexDirection:["column", "row"],
            justifyContent:"space-between",
            paddingBottom:["30px","40px","40px","50px"],
            rowGap:"15px",
            columnGap:"30px",
            alignItems:["flex-start","center"],
            overflow:"hidden",
          }}>
            <Box sx={{
              overflow:"hidden",
              maxWidth:"100%"
            }}>
              <Box sx={{
                fontSize:["26px","36px","36px","42px"],
                color:"text.black",
                paddingTop:["10px", "12px", "12px", "15px"],
                paddingBottom:["10px", "12px", "12px", "15px"],
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {languageValues?.myCertif?.homeWelcome[actLanguage]}
              </Box>
              <Box sx={{
                fontSize:["15px","19px","19px","22px"],
                color:"text.black",
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {languageValues?.myCertif?.homeWelcomeSub[actLanguage]}
              </Box>
            </Box>
            {currentUser?.groupes[0]?.img ? (
              <Box sx={{
                display:"flex",
                flexDirection:["row", "column"],
                rowGap:"15px",
                columnGap:"15px",
                overflow:"hidden",
                maxWidth:"100%",
              }}>
                <Hidden smDown>
                  <img src={GLB_URL_APIS+"/groupesLogos/"+currentUser?.groupes[0]?.img} style={{maxHeight:"60px", objectFit:"contain"}} />
                </Hidden>
                <Hidden smUp>
                  <img src={GLB_URL_APIS+"/groupesLogos/"+currentUser?.groupes[0]?.img} style={{maxHeight:"50px", objectFit:"contain"}} />
                </Hidden>
              </Box>
            ) : (
              <Box sx={{
                display:"flex",
                flexDirection:["row", "column"],
                rowGap:"15px",
                columnGap:"15px",
                overflow:"hidden",
                maxWidth:"100%",
              }}>
                <Hidden smDown>
                  <img src="/static/logo.png" style={{maxHeight:"60px", maxWidth:"200px", objectFit:"contain"}} />
                </Hidden>
                <Hidden smUp>
                  <img src="/static/logo.png" style={{maxHeight:"50px", maxWidth:"150px", objectFit:"contain"}} />
                </Hidden>
              </Box>
            )}
          </Box>
          {/* END TOP */}

          {/* VIDEO + GRAPH */}
          <Box sx={{
            paddingBottom:["25px","30px","30px","40px"],
            display:"flex",
            flexDirection:["column", "row", "row", "row"],
            columnGap:"35px",
            rowGap:["15px", "20px"],
            //maxHeight:["unset", "unset", "unset", "407px"],
            overflow:"hidden",
          }}>
            <Box
              onClick={() => { setSeeTuto(true) }}
              sx={{
                flex:[0.5, 0.5, 0.30, 0.30],
                border:"1px solid #E7E7E7",
                background:"lightgrey",
                backgroundRepeat:"no-repeat",
                backgroundImage:`url(${fakeVideoTuto})`,
                backgroundSize:"cover",
                backgroundPosition:"center center",
                overflow:"hidden",
                height:["180px", "270px", "270px", "367px"],
                minHeight:["180px", "270px", "270px", "367px"],
                cursor:"pointer",
                display:"flex",
                alignItems:"flex-end"
              }}
            >
              <Box sx={{
                color:"white",
                fontSize:["20px", "22px", "22px", "24px"],
                padding:"20px"
              }}>
                {languageValues?.myCertif?.tuto[actLanguage]}
              </Box>
            </Box>
            <Box sx={{
              flex:[0.5, 0.5, 0.7, 0.7],
              height:["410px", "270px", "270px", "367px"],
              minHeight:["410px", "270px", "270px", "367px"],
              display:data?.percentAllContentsEnded === 100 ? "flex" : ["none", "flex", "flex", "flex"],
              border:"1px solid #E7E7E7",
              background:"white",
              padding:["20px", "30px", "30px", "35px"],
              overflow:"hidden",
              justifyContent:"space-between",
              alignItems:"center",
              flexDirection:["column", "row", "row", "row"],
              gap:"20px",
              //height:"400px",
            }}>
              <Box sx={{
                display:"flex",
                flexDirection:"column",
                justifyContent:"space-around",
                height:"100%",
                maxWidth:data?.percentAllContentsEnded === 100 ? ["100%", "250px", "250px", "300px"] : ["100%", "100%", "250px", "300px"],
                padding:["0", "0", "0", "15px"],
              }}>
                <Box sx={{display:"flex", flexDirection:"column", gap:["5px", "10px", "10px", "15px"]}}>
                  <Box sx={{
                    color:"text.black",
                    fontSize:["22px", "26px", "26px", "36px"],
                    textAlign:["center", "left"],
                  }}>
                    {languageValues?.myCertif?.homeWelcome[actLanguage]}
                  </Box>
                  <Box sx={{
                    color:"text.subTitle",
                    fontSize:["15px", "17px", "20px", "20px"],
                    textAlign:["center", "left"],
                  }}>
                    {languageValues?.myCertif?.homeWelcomeSub[actLanguage]}
                  </Box>
                </Box>
                <Hidden smDown>
                  <MyButton
                    data={data}
                    toPDF={toPDF}
                  />
                </Hidden>
              </Box>
              <Hidden only={["sm"]}>
                <Box sx={{
                  overflow:"hidden",
                  flex:1,
                  width:"100%",
                }}>
                  {data?.percentAllContentsEnded === 100 ? (
                    <>
                      <Hidden only={["xs", "sm", "md"]}>
                        <NewCertifChart
                          datas={getDatasForChart()}
                          maxHeight="330px"
                        />
                      </Hidden>
                      <Hidden only={["xs", "sm", "lg", "xl"]}>
                        <NewCertifChart
                          datas={getDatasForChart()}
                          maxHeight="250px"
                        />
                      </Hidden>
                      <Hidden only={["sm", "md", "lg", "xl"]}>
                        <NewCertifChart
                          datas={getDatasForChart()}
                          maxHeight="230px"
                        />
                      </Hidden>
                    </>
                  ) : (
                    <Box sx={{
                      height:["0px", "0px", "230px", "330px"],
                      width:"100%",
                      backgroundRepeat:"no-repeat",
                      backgroundImage:`url(${fakeChartDataImage})`,
                      backgroundSize:"contain",
                      backgroundPosition:"center right",
                    }} />
                  )}
                </Box>
              </Hidden>
              <Hidden smUp>
                <MyButton
                  data={data}
                  toPDF={toPDF}
                />
              </Hidden>
            </Box>
          </Box>
          {/* END VIDEO + GRAPH */}

          {/* LISTE SKILLS */}
          <Box sx={{
            display:"flex",
            gap:"40px",
            paddingTop:"10px",
          }}>
            <Box sx={{
              flex:1,
              display:"flex",
              flexDirection:"row",
              justifyContent:"space-between",
              alignItems:"flex-start",
              gap:"20px",
            }}>
              <Box sx={{
                fontSize:["22px", "22px", "26px", "32px"],
                color:"text.black",
              }}>
                {languageValues?.myCertif?.skillsList[actLanguage]}
              </Box>
              <Hidden mdUp>
                <Box sx={{display:"flex", alignItems:"center", gap:"5px"}}>
                  <Button
                    variant="text"
                    disabled={selectedYear===0}
                    sx={{
                      minHeight:"25px !important",
                      minWidth:"15px !important",
                      height:"25px !important",
                      padding:"0",
                      "&:hover" : {
                        background:"transparent",
                        color:"rgba(0,0,0,0.75)",
                      },
                    }}
                    onClick={() => { setSelectedYear(selectedYear-1) }}
                  >
                    <KeyboardArrowDownIcon style={{transform:"rotate(90deg)"}}/>
                  </Button>
                  <Box sx={{flexShrink:0}}>
                    {languageValues?.myCertif?.year[actLanguage]} {selectedYear+1}
                  </Box>
                  <Button
                    variant="text"
                    disabled={data ? (selectedYear === data?.maxYear) : true}
                    sx={{
                      minHeight:"25px !important",
                      minWidth:"15px !important",
                      height:"25px !important",
                      padding:"0",
                      "&:hover" : {
                        background:"transparent",
                        color:"rgba(0,0,0,0.75)",
                      },
                    }}
                    onClick={() => { setSelectedYear(selectedYear+1) }}
                  >
                    <KeyboardArrowDownIcon style={{transform:"rotate(-90deg)"}}/>
                  </Button>
                </Box>
              </Hidden>
              <Hidden mdDown>
                <Box sx={{display:"flex", gap:["20px", "20px", "30px", "30px"]}}>
                  {data?.maxYear >= 0 &&
                    <Button
                      variant="text"
                      sx={{
                        minHeight:"30px !important",
                        height:"30px !important",
                        padding:"0px 10px",
                        borderBottom:selectedYear === 0 && "1px solid black",
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                        },
                      }}
                      onClick={() => { setSelectedYear(0) }}
                    >
                      {languageValues?.myCertif?.year[actLanguage]} 1
                    </Button>
                  }
                  {data?.maxYear >= 1 &&
                    <Button
                      variant="text"
                      sx={{
                        minHeight:"30px !important",
                        height:"30px !important",
                        padding:"0px 10px",
                        borderBottom:selectedYear === 1 && "1px solid black",
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                        },
                      }}
                      onClick={() => { setSelectedYear(1) }}
                    >
                      {languageValues?.myCertif?.year[actLanguage]} 2
                    </Button>
                  }
                  {data?.maxYear >= 2 &&
                    <Button
                      variant="text"
                      sx={{
                        minHeight:"30px !important",
                        height:"30px !important",
                        padding:"0px 10px",
                        borderBottom:selectedYear === 2 && "1px solid black",
                        "&:hover" : {
                          background:"transparent",
                          color:"rgba(0,0,0,0.75)",
                        },
                      }}
                      onClick={() => { setSelectedYear(2) }}
                    >
                      {languageValues?.myCertif?.year[actLanguage]} 3
                    </Button>
                  }
                </Box>
              </Hidden>
            </Box>
          </Box>
          <Box sx={{
            width:"100%",
            display:"flex",
            flexDirection:"column",
            gap:["8px", "11px", "12px", "13px"],
            overflow:"hidden",
            marginTop:["15px", "20px", "20px", "30px"]
          }}>
            {data?.skillsByYear[selectedYear]?.map((skill, index) => {
              let skillChecked = false
              if (skill?.finalScore >= 0 && skill?.finalScore <= 100) {
                if (skill?.finalScore >= skill?.validation) {
                  skillChecked = true
                }
              }
              return (
                <SkillResultCard
                  key={index}
                  name={skill?.key}
                  result={skill?.finalScore}
                  seuil={skill?.validation}
                  validSkill={skillChecked}
                />
              )
            })}
          </Box>
          {/* END LISTE SKILLS */}

          {data?.percentAllContentsEnded === 100 &&
            <Rapport
              ref={targetRef}
              user={currentUser}
              data={data}
              getDatasForChart={getDatasForChart}
            />
          }


        </Box>
      </Box>


      <ModalTuto
        isOpen={seeTuto}
        onClose={() => {
          setSeeTuto(false)
        }}
        title={languageValues?.adminDashboard?.homePage?.tutoTitle[actLanguage]}
        subTitle={languageValues?.adminDashboard?.homePage?.tutoSubTitle[actLanguage]}
        videoUrl={null}
      />
    </>
  )
};

const MyButton = ({data, toPDF}) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [isCreatingPDF, setIsCreatingPDF] = useState(false)

  return (
    <>
      <Hidden smDown>
        <Button
          onClick={async () => {
            if (isCreatingPDF === false) {
              setIsCreatingPDF(true)
              await toPDF()
              setIsCreatingPDF(false)
            }
          }}
          disabled={data?.percentAllContentsEnded === 100 ? isCreatingPDF : true}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            fontSize:"16px",
            whiteSpace:"nowrap",
            padding:0,
          }}
        >
          {data?.percentAllContentsEnded === 100 ? (
            <>{languageValues?.myCertif?.buttonDownload[actLanguage]}</>
          ) : (
            <>{languageValues?.myCertif?.buttonNotAvailable[actLanguage]}</>
          )}
        </Button>
      </Hidden>
      <Hidden smUp>
        <Button
          disabled={data?.percentAllContentsEnded === 100 ? isCreatingPDF : true}
          onClick={async () => {
            if (isCreatingPDF === false) {
              setIsCreatingPDF(true)
              await toPDF()
              setIsCreatingPDF(false)
            }
          }}
          size="large"
          type="submit"
          variant="contained"
          sx={{
            minHeight:"45px !important",
            height:"45px !important",
            fontSize:"15px",
            whiteSpace:"nowrap",
            paddingLeft:"30px",
            paddingRight:"30px",
          }}
        >
          {data?.percentAllContentsEnded === 100 ? (
            <>{languageValues?.myCertif?.buttonDownload[actLanguage]}</>
          ) : (
            <>{languageValues?.myCertif?.buttonNotAvailable[actLanguage]}</>
          )}
        </Button>
      </Hidden>
    </>
  )
}

export default MyCertif;
